import t from 'tcomb';
import Date_Schema from '../../web/domain/Date_Schema';
import jsdk from '../../jsdk';

const Radio_Input = t.struct({
  id: t.Str,
  options: t.maybe(t.Bool),
  schema: Date_Schema,
  attrs: t.maybe(t.Obj),
  hint: t.maybe(t.Str)
}, 'Radio_Input');
/*

function Radio_Input(id, options, schema, attrs, hint) {
  assert(Str.is(id));
  assert(List(Str_Option).is(options));
  assert(Str_Schema.is(schema));
  assert(Maybe(Obj).is(attrs));
  assert(Maybe(Str).is(hint));
  this.type = 'radio';
  this.id = id;
  this.options = options;
  this.schema = schema;
  this.attrs = attrs;
  this.hint = hint;
  return freeze(this);
}

Radio_Input.is = function(x) {
  return x instanceof Radio_Input;
};

Radio_Input.of = function(x) {
  assert(Obj.is(x));
  return new Radio_Input(
    Str.of(x.id),
    List(Str_Option).of(x.options),
    Str_Schema.of(x.schema),
    Maybe(Obj).of(x.attrs),
    Maybe(Str).of(x.hint)
  );
};
*/
function radio_group(options, name, attrs, value) {
  attrs = attrs || {};
  attrs['class'] = attrs['class'] || [];

  var opt = function(option) {
    //t.assert([t.tuple([t.Str, t.Str])].is(option));
    return '<div class="group-input">' + jsdk.dom.radio({
      value: option[0],
      name: name,
      checked: option[0] === value
    }) + '</div><div class="group-label">' + option[1] + '</div>';
  };

  return jsdk.dom.div(options.map(opt).join(''), attrs);
}

Radio_Input.prototype.to_html = function(value) {
  //t.assert(t.maybe(JSON_Value).is(value));
  //t.assert(Locale.is(locale));
  var id = this.id;
  var attrs = !t.Nil.is(this.attrs) ? jsdk.copy(this.attrs) : {};
  attrs.id = id;
  var styles = jsdk.split_margins(attrs.style);
  attrs.style = styles.other;
  return jsdk.Form.wrap_input(id, radio_group(this.options, id, attrs, value), styles.margins, this.hint);
};

Radio_Input.prototype.focus = function() {
  $('#' + this.id + ' input[type=radio]').get(0).focus();
};

Radio_Input.prototype.set_error = function(message) {
  $("#" + this.id + "_error").html(message);
};

Radio_Input.prototype.value = function(locale) {
  //t.assert(Locale.is(locale));
  var id = this.id;
  var value = $('#' + id + ' input[type=radio]:checked').val() || "";
  var validation = this.schema.validate(value, locale);
  this.set_error(validation.rule ? validation.rule.localize(locale) : '');
  return validation;
};

jsdk.Form.add_input('radio', Radio_Input);


export default Radio_Input;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/form/base/Radio_Input.js
 **/